import React, { useState, useEffect } from "react";
import Wysiwyg from "../../../components/Wysiwyg/Wysiwyg";
import ToolbarRow from "../../../components/Wysiwyg/toolbar/ToolbarRow";
import TextStylesToolbarGroup from "../../../components/Wysiwyg/toolbar/groups/TextStylesToolbarGroup";
import ToolbarDivider from "../../../components/Wysiwyg/toolbar/ToolbarDivider";
import AlignToolbarGroup from "../../../components/Wysiwyg/toolbar/groups/AlignToolbarGroup";
import HeadingsToolbarGroup from "../../../components/Wysiwyg/toolbar/groups/HeadingsToolbarGroup";
import { Label } from "reactstrap";
import HistoryToolbarGroup from "../../../components/Wysiwyg/toolbar/groups/HistoryToolbarGroup";

const EditorEmail  = props => {

  const {
    text,
    setText,
  } = props;

  return (
    <div className="row">
      <div className="col-md-12">
        <Wysiwyg
          value={text}
          onChange={setText}
          toolbar={() => 
            <ToolbarRow>
              <HistoryToolbarGroup />
              <ToolbarDivider />
              <TextStylesToolbarGroup />
              <ToolbarDivider />
              <AlignToolbarGroup />
              <ToolbarDivider />
              <HeadingsToolbarGroup headings={[1, 2, 3]} />
            </ToolbarRow>
          }
        />
      </div>
    </div>
  );
}

export default EditorEmail;